// 直连预订续住
import {
  ReducerState,
  MainState,
  storeName,
  RenewalRentRoomInfo,
} from '@/redux/reducers/reservation/directRenewal';

import { DirectRenewalCreateAction } from './constant';
import { createActionMiddleware } from './helper';

// getState函数覆写
const actionWrapper = createActionMiddleware<ReducerState>(storeName);

/**
 * 更新loading状态
 * 加个timer防止重复修改时闪烁
 */
let loadingTimer;
export const setLoadingStatus: (isLoading: boolean) => void = (isLoading) => {
  if (loadingTimer) {
    clearTimeout(loadingTimer);
  }
  return actionWrapper((dispatch, getState) => {
    // 和当前状态不一样
    loadingTimer = setTimeout(() => {
      loadingTimer = null;
      if (getState().isLoading !== isLoading) {
        dispatch({
          type: DirectRenewalCreateAction.setLoadingStatus,
          payload: isLoading,
        });
      }
    });
  });
};

// 更新初始化状态
const setInitStatus = (isInit: boolean) => {
  return { type: DirectRenewalCreateAction.setInitStatus, payload: isInit };
};

// 页面初始化
export const initPageState: (initFunc: () => Promise<MainState>) => void = (initFunc) => {
  return async (dispatch) => {
    try {
      // 未初始化状态
      dispatch({
        type: DirectRenewalCreateAction.initDefaultState,
        payload: <ReducerState>{
          isInit: false,
          isLoading: true,
          customerInfo: {},
          rentRoomInfos: [],
          targetRoomMap: {},
          remarkInfo: {},
        },
      });
      // 调用初始化方法
      const initState = await initFunc();
      // 设置初始化数据
      dispatch({ type: DirectRenewalCreateAction.initDefaultState, payload: initState });
      dispatch(setInitStatus(true));
      dispatch(setLoadingStatus(false));
    } catch (e) {
      dispatch(setInitStatus(false));
    }
  };
};

// 交换房间位置
export const swapRoomIndex = (sourceItem: RenewalRentRoomInfo, targetItem: RenewalRentRoomInfo) => {
  return actionWrapper((dispatch, getState) => {
    //  同一个房型调整
    if (sourceItem && targetItem && sourceItem.roomTypeId === targetItem.roomTypeId) {
      const { rentRoomInfos } = getState();
      const sourceIndexId = sourceItem.indexId;
      const targetIndexId = targetItem.indexId;
      dispatch({
        type: DirectRenewalCreateAction.setRentRoomList,
        payload: rentRoomInfos.map((item) => {
          if (item.indexId === sourceIndexId) {
            return { ...item, targetId: targetItem.targetId };
          }
          if (item.indexId === targetIndexId) {
            return { ...item, targetId: sourceItem.targetId };
          }
          return item;
        }),
      });
    }
  });
};

// 获取全部状态
export const getMainState: (callback: (state: ReducerState) => void) => void = (callback) => {
  return actionWrapper((_, getState) => {
    try {
      callback(getState());
    } catch (e) {
      //
    }
  });
};
